module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/qhead9-ac33476a428fe80e5f8e9924b867bb68.jpg";